const tooltip = require('tether-tooltip');

module.exports = tooltip;
